export const showToast = (ref, title, description, isError = false) =>
    ref &&
    ref.$toast({
        title,
        description,
        status: isError ? "error" : "success",
        duration: 10000,
        isClosable: true,
        position: "top",
    });